import { NgModule } from '@angular/core';
import { CountdownFormatPipe } from './pipes/coundown-format.pipe';
import { TruncateStringPipe } from './pipes/truncate-string.pipe';
import { RelativeTimePipe } from './pipes/relative-time.pipe';
import { CustomDatePipe } from './pipes/custom-date.pipe';
import { NumberFormatPipe } from './pipes/number-format.pipe';
import { SortByInteractionsPipe } from './pipes/sort-by-interactions.pipe';
import { SortPipe } from './pipes/sort.pipe';
import { SlugifyPipe } from './pipes/slugify.pipe';
import { BytesConversionPipe } from './pipes/bytes-conversion.pipe';
import { FilterPipe } from './pipes/filter.pipe';
import { DatetimeFormatterModule, DateFormatPipe } from '@soctrip-common/datetime-formatter'
import { DatePipe } from '@angular/common';
import { LocalizedNamePipe } from './pipes/localized-name.pipe';

import { CommonModule, TitleCasePipe } from '@angular/common';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';
import { DialogModule } from 'primeng/dialog';
import { ModalComponent } from './components/modal/modal.component';
import { ToastComponent } from './components/toast/toast.component';
import { Toast, ToastModule } from 'primeng/toast';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ModalModule } from 'ngx-bootstrap/modal';
import { DropdownModule } from 'primeng/dropdown';
import { GalleriaModule } from 'primeng/galleria';
import { OverlayModule } from 'primeng/overlay';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TabMenuModule } from 'primeng/tabmenu';
import { TabViewModule } from 'primeng/tabview';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { InputNumberModule } from 'primeng/inputnumber';
import { SkeletonModule } from 'primeng/skeleton';
import { TranslateModule } from '@ngx-translate/core';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { AutoCompleteModule } from 'primeng/autocomplete';

import { PaginationCustomComponent } from './components/pagination-custom/pagination-custom.component';
import { ShowImageModalComponent } from './components/show-image-modal/show-image-modal.component';
import { CustomizePaginationComponent } from './components/customize-pagination/customize-pagination.component';
import { TimePickerComponent } from './components/time-picker/time-picker.component';
import { PopupRecommendSignIn } from './components/popup-recommend-sign-in/popup-recommend-sign-in.component';
import { SignInRequestDialogComponent } from './components/sign-in-request-dialog/sign-in-request-dialog.component';
import { PopupCtaComponent } from './components/popup-cta/popup-cta.component';
import { PriceFormatComponent } from './components/price-format/price-format.component';
import { CommonIconText } from './components/common-icon-text/common-icon-text.component';
import { TooltipModuleBooking } from './components/tooltip/tooltip.module';
import { CheckboxModule } from 'primeng/checkbox';
import { RadioButtonModule } from 'primeng/radiobutton';
import { LoadingComponent } from './components/loading/loading.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { MeesageErrorFormModule } from './components/meesage-error-form/meesage-error-form.module';
import { DividerModule } from 'primeng/divider';
import { SliderModule } from 'primeng/slider';
import { ButtonComponent } from './components/button/button.component';
import { CalendarComponent } from './components/calendar/calendar.component';
import { SentenceCasePipe } from '../core/pipes/sentence-case.pipe';
import { CalendarModule } from 'primeng/calendar';
import { PaginatorModule } from 'primeng/paginator';
import { BookingMenuComponent } from './components/booking-menu/booking-menu.component';
import { CurrencyConversionPipe } from '@soctrip-common/app-security';
import { BannersComponent } from './components/banners/banners.component';
import { SafeURLPipe } from './pipes/safe-url.pipe';
import { InputMaskModule } from 'primeng/inputmask';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { FlightScheduleComponent } from './components/flight-schedule/flight-schedule.component';
import { SelectButtonRoundTripComponent } from './components/select-button-round-trip/select-button-round-trip.component';
import { GuestInfoComponent } from './components/guest-info/guest-info.component';
import { BaggageDetailsComponent } from './components/baggage-details/baggage-details.component';
import { PromotionBannerComponent } from './components/promotion-banner/promotion-banner.component';
import { CarouselModule } from 'primeng/carousel';
import { VoucherComponent } from './components/voucher/voucher.component';
import { CarouselComponent } from './components/carousel/carousel.component';
import { TooltipMembershipComponent } from './components/tooltip-membership/tooltip-membership.component';
import { PreviewMediaComponent } from './components/preview-media/preview-media.component';
import { SuggestedForYouComponent } from './components/suggested-for-you/suggested-for-you/suggested-for-you.component';
import { FlightDetailsPopupComponent } from './components/flight-details-popup/flight-details-popup.component';
import { PopupPreviewComponent } from './components/popup-preview/popup-preview.component';
import { OrderNotesComponent } from './components/order-notes/order-notes.component';
import { FormatPhonePipe } from './pipes/format-phone.pipe';
import { FormatUtcZPipe } from './pipes/format-utc-z.pipe';
import { FormatDatePipe } from './pipes/format-date.pipe';

const sharedPipes = [
  CountdownFormatPipe,
  TruncateStringPipe,
  RelativeTimePipe,
  CustomDatePipe,
  RelativeTimePipe,
  NumberFormatPipe,
  SortByInteractionsPipe,
  SortPipe,
  SlugifyPipe,
  BytesConversionPipe,
  FilterPipe,
  SentenceCasePipe,
  SafeURLPipe,
  SafeHtmlPipe,
  LocalizedNamePipe,
  FormatPhonePipe,
  FormatUtcZPipe,
  FormatDatePipe
];
const shareProviders = [
  Toast,
  DialogService,
  DynamicDialogRef,
  ConfirmationService,
  DatePipe,
  DateFormatPipe,
];
const shareModules = [
  DialogModule,
  ButtonModule,
  InputTextModule,
  FormsModule,
  ReactiveFormsModule,
  OverlayPanelModule,
  BsDatepickerModule,
  ModalModule,
  DropdownModule,
  ToastModule,
  TagModule,
  TooltipModule,
  GalleriaModule,
  OverlayModule,
  TabViewModule,
  TabMenuModule,
  TranslateModule,
  ProgressSpinnerModule,
  TooltipModuleBooking,
  InputNumberModule,
  CheckboxModule,
  RadioButtonModule,
  SkeletonModule,
  ConfirmDialogModule,
  MeesageErrorFormModule,
  SliderModule,
  DividerModule,
  CalendarModule,
  PaginatorModule,
  InputTextareaModule,
  CurrencyConversionPipe,
  DatetimeFormatterModule,
  InputMaskModule,
  CarouselModule,
  AutoCompleteModule,
];
const shareComponents = [
  ModalComponent,
  ToastComponent,
  PaginationCustomComponent,
  ShowImageModalComponent,
  CustomizePaginationComponent,
  TimePickerComponent,
  PopupRecommendSignIn,
  SignInRequestDialogComponent,
  PopupCtaComponent,
  PriceFormatComponent,
  CommonIconText,
  LoadingComponent,
  ButtonComponent,
  CalendarComponent,
  BookingMenuComponent,
  BannersComponent,
  FlightScheduleComponent,
  SelectButtonRoundTripComponent,
  GuestInfoComponent,
  BaggageDetailsComponent,
  PromotionBannerComponent,
  VoucherComponent,
  CarouselComponent,
  TooltipMembershipComponent,
  PreviewMediaComponent,
  SuggestedForYouComponent,
  FlightDetailsPopupComponent,
  PopupPreviewComponent,
  OrderNotesComponent,
];
@NgModule({
  declarations: [sharedPipes, shareComponents],
  imports: [CommonModule, shareModules],
  exports: [CommonModule, sharedPipes, shareComponents, shareModules],
  providers: [shareProviders, TitleCasePipe],
})
export class SharedModule {}
